// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"74bbf9d2","178":"f2fea2a9","388":"15422d1a","453":"af507fb7","595":"50cd3f9f"}[chunkId] + ".chunk.js";
};